import { LinkPillWithPopover } from "components/common/LinkPillWithPopover";
import strings from "components/release/useful-links/UsefulLinks.strings.json";
import styles from "components/release/useful-links/UsefulLinksAndroid.module.scss";
import { generateBuildLinks } from "components/release/useful-links/helpers";
import type { SemVer } from "util/version";

interface Props {
  versions: SemVer[];
  appBuildUrls: Record<string, string | undefined>;
}

const UsefulLinksIOS = ({ versions, appBuildUrls }: Props) => (
  <span className={styles.container}>
    <LinkPillWithPopover
      linkPillTitle={strings.DownloadBuild}
      linkPillWidth="150px"
      popoverContent={<ul>{generateBuildLinks(versions, appBuildUrls)}</ul>}
    />
  </span>
);

export default UsefulLinksIOS;
